<style scoped>
::v-deep .el-progress__text{
    font-size: 10px!important;
}
.demo-1-hero {
    display: grid;
    align-items: center;
    align-content: center;
    min-height: 0px;
    text-align: center;
}

.contactusblockpair-1 {
    display: block;
   
}

/*.accordion-button:not(.collapsed) {
    color: #484848;
    background-color: #e7f1ff00;
    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}*/

.accordion-button {
    padding: 5px 15px;
    font-size: 1rem;
    font-weight: 800;
    color: var(--bs-accordion-active-color);
}

.accordion-body {
    padding: 10px 15px;
    font-size: .9rem;
}

.accordion-body p {
    border-bottom: 1px #adb5bd dashed;
}

.accordion {
    --bs-accordion-bg: #ffffff4a;
}

.title_1 {
    color: #ce0c05
}

.res .nav .nav-link {
    color: var(--bs-gray-700);
}

.res .nav .active {
    color: var(--bs-link-color);
    background-color: #fff0;
    border-bottom-color: #eef0f4;
}
::v-deep .el-select__wrapper.is-filterable {
    height: 36px!important;
}
::v-deep .el-message--error{
    z-index: 9999!important;
}
::v-deep .el-upload,::v-deep .el-upload-dragger{
    height:100%
}

.el-table >>> th.el-table__cell {
    background-color: #F2F2F7;
}
</style>

<template>

   


<section class="sec-pad position-relative" style="padding-top: 100px;">
    
    <div class="container index-up">
        <div class="row">
            <div class="col-lg-12">
                <div class="contactusblockpair-1 shadow roundimg">
                    
                    <div class="infoblockz sw-bg-3-wave" style=" background: white;margin-top:25px">
                        <div v-if="tableData.length == 0" class="contactinfodivv"><img src="/statics/images/empty@2x.png" style="height:220px;width:240px"/></div>
                        <div v-else class="contactinfodivv" style="display: flex; flex-wrap: wrap; width: 100%;">
                            <div class="con-block-sw-div" style="min-height: 100px;width:100%">
                                <div>
                                    <el-table :data="tableData" style="width: 100%">
                                        <el-table-column prop="filename" label="File Name" ></el-table-column>
                                        <el-table-column prop="promptInfo.name" label="Checklist" ></el-table-column>
                                        <el-table-column label="Upload time" width="160">
                                            <template #default="scope">
                                                <div style="display: flex; ">
                                            
                                                    <span>{{ new Date(scope.row.createdAt).toLocaleString() }}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Update time" >
                                            <template #default="scope">
                                                <div style="display: flex; ">
                                            
                                                    <span>{{ new Date(scope.row.updatedAt).toLocaleString() }}</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Status" >
                                            <template #default="scope">
                                                <div style="display: flex; ">
                                                    <el-progress v-if="state.progressData[scope.row.id]" type="circle" width="45" :percentage="state.progressData[scope.row.id]" :stroke-width="6"/>
                                                    <span v-else-if="scope.row.status === '4'"> Pending</span>
                                                    <span v-else-if="scope.row.status === '1'"> Pending</span>
                                                    <span v-else-if="scope.row.status === '2'"> Completed</span>
                                                    <span v-else>Error</span>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Operation">
                                            <template #default="scope">
                                                <!-- <el-button size="small" @click="handleDown(scope.$index, scope.row)">
                                                下载
                                                </el-button> -->
                                                <el-button link size="small" :style="{
                                                    border: 0, 
                                                    color: scope.row.status === '2' ? '#04A3AE' : '#B0B0B0', 
                                                    cursor: scope.row.status === '2' ? 'pointer' : 'not-allowed'
                                                }"  :disabled="scope.row.status !== '2'" @click="gotoDetail(scope.$index, scope.row)">
                                                Detail
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="total"
                                    :page-size="pageSize"
                                    :current-page="currentPage"
                                    @current-change="handleCurrentChange"
                                    style="margin-top: 10px;float: right;"
                                    ></el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

</template>
<script lang="ts">
  export default {
    name: 'CheckListView',
  };
  
  </script>
  <script setup lang="ts">
    import { ref,toRaw,reactive, onMounted, watch, onBeforeUnmount} from 'vue';
    import { useRouter } from 'vue-router';
    import { genFileId ,ElMessage,ElLoading} from 'element-plus';
    import type { UploadFile, UploadInstance, UploadProps, UploadRawFile,ElProgress } from 'element-plus';
    import { checkListGetall, getProgress, judgeChecklist} from "../api/modules/api.checklist";
    import {getList,create,downloadExcel} from "../api/modules/api.upload";
    import dbUtils from '../libs/util.strotage.js'
    import {authIsLogin} from '../api/modules/api.auth.js';

    const tableData = ref([]);
    const total = ref(0);
    const pageSize = ref(10);
    const currentPage = ref(1);
    const router = useRouter();
    const userInfo = dbUtils.get('FrontuserInfo')
    let uploadsIds = dbUtils.get("UploadsIds")
    const ifLogin = ()=>{
        authIsLogin().then(res => {
            console.log(res)
            if(!res.data){
                dbUtils.remove("FrontuserInfo") //去掉登录信息
            }
            fetchData();
        })
    }
    const fetchData = async (page = 1) => {
        try {
            let p = {
                pagination:{"current":page,
                            "pageSize":pageSize.value
                }
            }
            if(!userInfo){
                p["params"] = {}
                p["params"]["id"] = [null]
                if(uploadsIds){
                    p["params"]["id"] = uploadsIds.slice(0,10) //最多10个
                }
                

            }
            getList(p).then(res => {
                state.loading.spinning = false
                let datas = res.data.result
                
                tableData.value = datas
                total.value = res.data.total
                state.query.pagination.current = res.data.current
                state.query.pagination.pageSize = res.data.pageSize
            }).catch(err => {
                state.loading.spinning = false
                console.log(err)
            })
        
       
        } catch (error) {
        ElMessage.error('获取数据失败');
        }
    };
    const get_progress = ()=>{
        getProgress().then(res => {
            const keys1 = Object.keys(state.progressData);
            const keys2 = Object.keys(res.data);
            if(JSON.stringify(keys1) !== JSON.stringify(keys2)){
                fetchData(currentPage.value);
            }
            state.progressData = res.data
        })
    };
    const state = reactive({
      progressData:{},
      show: {
        add: false,
        edit: false,
        view: false
      },
      activeComponent: null,
      // 暂存更新数据
      updateData: {},
      // 暂存查看数据
      viewData: {},
      dataList: [],
      // 请求参数
      query: {
        params: {},
        pagination: {
          current: 1,
          pageSize: 5,
          total: 0,
          hideOnSinglePage: true,
        },
        sort: {
          columnKey: "createdAt",
          order: "ascend"
        }
      },
      // loading
      loading: {
        spinning: false,
        tip: '加载中'
      }
    })
    let timer
    let timer2
  const fileName = ref('')
  const upload = ref<UploadInstance>()
  const fileUp = ref()
 
  const handleCurrentChange = (page) => {
      currentPage.value = page;
      fetchData(page);
    };

  
  const gotoDetail = (item, items)=>{
    //router.push({ name: 'Detail', params: { id: items.id } });
    const url = `/detail/${items.id}`;
    window.open(url, '_blank');
  }

    const startRefreshing = () => {
        
        timer = setInterval(() => {
            fetchData(currentPage.value);
        }, 1000*60); // 每 60 秒刷新一次
        timer2 = setInterval(() => {
            get_progress()
        }, 1000*10); // 每 10 秒刷新一次
    };

    const stopRefreshing = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
       
        if(timer2){
            clearInterval(timer2);
            timer2 = null;
        }
    };
   
    // 当组件挂载时，尝试从localStorage读取保存的选择值
    onMounted(() => {
        ifLogin();
       
        startRefreshing();
    });
    onBeforeUnmount(() => {
      stopRefreshing();
    });

  </script>